import { SpotlightTourStep } from "components/ProductAnnouncement/SpotlightTour";

export const SCOUT_LAUNCH_URL = "https://support.encamp.com/en/articles/11972993";

export const SCOUT_LAUNCH_MODAL_COPY = {
  headline: "Meet Scout",
  subheadline: "Encamp's new compliance expert",
  learnMoreLabel: "Learn more about Scout",
  startTourLabel: "Show me where it is",
} as const;

/** Lives inside the temporary left-nav drawer below the md breakpoint. */
export const SCOUT_NAV_ANCHOR_ID = "scout-nav";

export const SCOUT_LAUNCH_TOUR_STEPS: SpotlightTourStep[] = [
  {
    anchorId: "scout-launcher",
    title: "Talk to Scout",
    body: "Ask Scout questions from anywhere in the platform.",
    placement: "bottom",
  },
  {
    anchorId: SCOUT_NAV_ANCHOR_ID,
    title: "The full Scout experience",
    body: "Access your Scout history and citation records whenever you need them.",
    placement: "right",
  },
];
